import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-24 md:py-32 bg-background-900 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20flowing%20geometric%20patterns%20with%20warm%20golden%20accents%20on%20dark%20background%2C%20minimalist%20tech%20style%2C%20soft%20glowing%20lines%2C%20elegant%20ambient%20texture%2C%20subtle%20light%20rays&width=1920&height=800&seq=cta-bg-nagihikari&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-semibold text-background-50 mb-4">
          准备好开始了吗？
        </h2>
        <p className="text-sm text-background-300 max-w-xl mx-auto mb-10 leading-relaxed">
          加入超过 500 万用户的行列，体验凪光在线带来的流畅与便捷。立即注册，开启您的在线之旅。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/platform-guide"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            免费注册使用
            <i className="ri-user-add-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-background-50/10 text-background-50 font-medium rounded-full border border-background-50/20 hover:bg-background-50/20 transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
          >
            联系咨询
            <i className="ri-chat-3-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}